// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"72e7c405","160":"a6d08e76","208":"fd0f2382","293":"0f82c7f5","453":"da0ce14c","516":"b83b91d5","519":"ab1cb959","917":"b4f7995b","946":"4a0580d3"}[chunkId] + ".chunk.js";
};